/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reps: NonNullable<unknown> }} Offline_Set_BodyweightInputs */

const en_us2_offline_set_bodyweight = /** @type {(inputs: Offline_Set_BodyweightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bodyweight × ${i?.reps}`)
};

const pt_br2_offline_set_bodyweight = /** @type {(inputs: Offline_Set_BodyweightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso corporal × ${i?.reps}`)
};

const es_419_offline_set_bodyweight = /** @type {(inputs: Offline_Set_BodyweightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso corporal × ${i?.reps}`)
};

const pt_pt2_offline_set_bodyweight = /** @type {(inputs: Offline_Set_BodyweightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso corporal × ${i?.reps}`)
};

const fr_fr2_offline_set_bodyweight = /** @type {(inputs: Offline_Set_BodyweightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Poids du corps × ${i?.reps}`)
};

const de_de2_offline_set_bodyweight = /** @type {(inputs: Offline_Set_BodyweightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Körpergewicht × ${i?.reps}`)
};

const it_it2_offline_set_bodyweight = /** @type {(inputs: Offline_Set_BodyweightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Corpo libero × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "Bodyweight × {reps}" |
*
* @param {Offline_Set_BodyweightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_set_bodyweight = /** @type {((inputs: Offline_Set_BodyweightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Set_BodyweightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_set_bodyweight(inputs)
	if (locale === "es-419") return es_419_offline_set_bodyweight(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_set_bodyweight(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_set_bodyweight(inputs)
	if (locale === "de-DE") return de_de2_offline_set_bodyweight(inputs)
	if (locale === "it-IT") return it_it2_offline_set_bodyweight(inputs)
	return en_us2_offline_set_bodyweight(inputs)
});
export { offline_set_bodyweight as "offline.set_bodyweight" }